<template>
  <v-card>
    <div v-if=shouldDisplayResponseCardTitle>
      <v-card-title v-if="responseCard.title && responseCard.title.trim()" primary-title class="green lighten-5">
        <span class="headline">{{responseCard.title}}</span>
      </v-card-title>
    </div>
    <div style="text-align:center">
    <v-card-text v-if="responseCard.title">
      <span style="font-weight:bold">{{responseCard.title}}</span>
    </v-card-text>
    <v-card-text v-if="responseCard.subTitle">
      <span style="font-weight:bold">{{responseCard.subTitle}}</span>
    </v-card-text>
    </div>
    <v-card-media
      v-if="responseCard.imageUrl"
      v-bind:src="responseCard.imageUrl"
      contain
      height="22vh"
    ></v-card-media>
 <v-layout align-center justify-center>
    <v-card-actions v-if="responseCard.buttons" class="button-row" >
      <v-btn class="custom" justify-content= "center"
        v-for="(button) in responseCard.buttons"
        v-show="button.text && button.value"
        v-bind:key="button.id"
        v-on:click.once.native="onButtonClick(button.value,button.text)"
        round
        default
        v-bind:color="button.text.toLowerCase() === 'more' ? '' : 'accent'"
      >
<span style="font-family:sans serif"> {{button.text}}</span>
       
      </v-btn>
    </v-card-actions>
</v-layout>
  </v-card>
</template>


<script>
/*
Copyright 2017-2019 Amazon.com, Inc. or its affiliates. All Rights Reserved.

Licensed under the Amazon Software License (the "License"). You may not use this file
except in compliance with the License. A copy of the License is located at

http://aws.amazon.com/asl/

or in the "license" file accompanying this file. This file is distributed on an "AS IS"
BASIS, WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, express or implied. See the
License for the specific language governing permissions and limitations under the License.
*/
export default {
  name: 'response-card',
  props: ['response-card'],
  data() {
    return {
      hasButtonBeenClicked: false,
    };
  },
  computed: {
    shouldDisplayResponseCardTitle() {
      return this.$store.state.config.ui.shouldDisplayResponseCardTitle;
    },
    shouldDisableClickedResponseCardButtons() {
      return (
        this.$store.state.config.ui.shouldDisableClickedResponseCardButtons &&
        this.hasButtonBeenClicked
      );
    },
  },
  methods: {
    onButtonClick(value, text) {
      this.hasButtonBeenClicked = true;
      const messageType = this.$store.state.config.ui.hideButtonMessageBubble ? 'button' : 'human';
      const message = {
        type: messageType,
        text: value,
        text2: text,
      };

      this.$store.dispatch('postTextMessage', message);
    },
  },
};

</script>

<style scoped>
.headline{
font-family:"sans serif";
}
.card {
  width: 70vw;
  position: inherit; /* workaround to card being displayed on top of toolbar shadow */
  padding-bottom: 0.2em;
  box-shadow: none !important;
  background-color: unset !important;
}
.card__title {
  padding: 0.5em;
  padding-top: 0.75em;
}
.card__text {
  padding: 0.32em;
}


.card__actions .btn {
  margin: 3px;
  font-size: 0.80em;
  min-width: 15px;
  display: block;
}

.custom {
    width: 150px !important;
    margin: 7px;
    margin-bottom: 6.5px !important;
    background-color:#b5c0c9 !important;
}

.card__actions.button-row {
  margin: auto 17px;
  padding-bottom: 0.80em;
  display: block;
}


.example-slide {
  align-items: center;
  justify-content: center;
  min-height: 10rem;
}
</style>



// WEBPACK FOOTER //
// src/components/ResponseCard.vue